<ng-template #tooltipTemplate>
  <div class="categories-tooltip">
    <!-- Show current categories -->
    @if (data().current?.length) {
      <div class="tooltip-section">
        <div *ngFor="let category of data().current" class="tooltip-chips">
          <mat-chip [removable]="false" class="category-chip">
            <mat-chip-avatar [ngStyle]="{ 'background-color': '#8D57BE' }"></mat-chip-avatar>
            {{ category.name }}
          </mat-chip>
        </div>
      </div>
    } @else {
      <div class="tooltip-section">
        <h4 class="m-0">No categories.</h4>
      </div>
    }

    <!-- Show previous data section -->
    @if (data().previous?.length) {
      <div class="tooltip-section">
        <h4 class="m-0">Previous data:</h4>
        <div *ngFor="let category of data().previous" class="tooltip-chips">
          <mat-chip [removable]="false" class="category-chip">
            <mat-chip-avatar [ngStyle]="{ 'background-color': '#8D57BE' }"></mat-chip-avatar>
            {{ category.name }}
          </mat-chip>
        </div>
      </div>
    }
  </div>
</ng-template>
